// components/LanguageSelector.tsx
import React, { useState, useEffect } from 'react';
import { changeLanguage } from 'i18next';
import Cookies from 'js-cookie';

interface Props {
  onLangChange: (lang: string) => void;
}

const languages = [
  { code: 'ar', name: 'العربية' },
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' },
];

const LanguageSelector: React.FC<Props> = ({ onLangChange }) => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState<string>('ar');

  useEffect(() => {
    const saved = Cookies.get('lang') || 'ar';
    setCurrent(saved);
  }, []);

  const selectLang = (lang: string) => {
    Cookies.set('lang', lang, { expires: 365, path: '/' });
    changeLanguage(lang);
    setCurrent(lang);
    onLangChange(lang);
    setOpen(false);
  };

  return (
    <>
      <button
        onClick={() => setOpen(o => !o)}
        className="
          fixed bottom-4 right-4 sm:bottom-6 sm:right-6
          bg-blue-600 hover:bg-blue-700 text-white
          p-3 rounded-full shadow-lg z-50
          focus:outline-none focus:ring-2 focus:ring-blue-400
        "
        aria-label="تغيير اللغة"
      >
        🌐
      </button>

      {open && (
        <div
          className="
            fixed bottom-20 right-4 sm:bottom-24 sm:right-6
            bg-white dark:bg-gray-800
            rounded-lg shadow-xl
            p-4 w-48 sm:w-56
            grid grid-cols-1 gap-2
            z-50
          "
        >
          {languages.map(lang => (
            <button
              key={lang.code}
              onClick={() => selectLang(lang.code)}
              className={`
                text-left px-3 py-2 rounded
                ${current === lang.code
                  ? 'bg-blue-100 dark:bg-blue-900'
                  : 'hover:bg-gray-100 dark:hover:bg-gray-700'}
              `}
            >
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default LanguageSelector;
